const STANDARD_PRODUCT = 'standard_product';
const EXTRA_GUARANTEE = 'extra_guarantee';
const ITEM_ACCESSORY = 'accessory';
const ITEM_PRODUCT = 'product';
export { STANDARD_PRODUCT };
export { EXTRA_GUARANTEE };
export { ITEM_ACCESSORY };
export { ITEM_PRODUCT };
